import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useLocaleMessaging } from '../hooks/useLocaleMessaging';
import parentFrameMessaging from '../services/ParentFrameMessaging';

const Default: React.FC = () => {
  const navigate = useNavigate();

  // Initialize locale messaging to listen for PMC_HANDSHAKE messages
  useLocaleMessaging();

  // Send handshake message to parent on mount with retry until handshake received
  useEffect(() => {
    const stopRetry = parentFrameMessaging.sendIframeReadyWithRetry();
    return stopRetry;
  }, []);

  useEffect(() => {
    const unsubscribe = parentFrameMessaging.onTestMode(() => {
      navigate('/game');
    });
    return unsubscribe;
  }, [navigate]);

  return <div></div>;
};

export default Default;
